import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module.js';
import { InstallButtonComponent } from './install-button.component.js';
import { InstallComponent } from './install.component.js';

@NgModule({
	imports: [CoreModule],
	declarations: [InstallComponent, InstallButtonComponent],
	exports: [InstallComponent, InstallButtonComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InstallModule {}
